import React, { useState, useEffect, useCallback } from 'react';
import { SingleFileState } from 'screens/EpisodeOptionsScreen/components/EpisodeContent/SingleFileState';
import { useUploadFileMultipart } from 'client/hooks/upload/useUploadFileMultipart';
import { useQuickUploadFile } from 'contexts/QuickUploadFile';
import { UploadingState } from './UploadingState';
import { EpisodeContentLabel, UploaderStateContainer } from './styles';
import { IdleState } from './IdleState';

export const EpisodeContent = () => {
  const { quickUploadFile } = useQuickUploadFile();
  const [isUploading, setUploading] = useState(false);
  const [isProcessing, setProcessing] = useState(false);
  const [media, setMedia] = useState(quickUploadFile);
  // TODO : Hook up Uploading UI, will be implemented by WHEEL-780
  // https://anchorfm.atlassian.net/browse/WHEEL-780
  // Can use the uploadFileMultipartStatus flag to govern
  // loading and error states
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const {
    uploadFileMultipart,
    uploadFileMultipartStatus,
  } = useUploadFileMultipart();

  const isMultiSegmentFile = (file: File | null) => {
    // TODO : Dummy implementation, replace with count of episodeAudios
    // Will be implemented by WHEEL-783
    // https://anchorfm.atlassian.net/browse/WHEEL-783
    return file ? file.type === 'audio' : false;
  };

  const onProgressUpload = (loaded: number, total: number) => {
    const percent = Math.round(Math.round((loaded / total) * 100 * 100) / 100);
    setUploadPercentage(percent);
  };

  const onErrorUpload = () => console.log('Error uploading file');

  const onUploadFile = useCallback(
    (file: File) => {
      setUploading(true);
      setMedia(file);
      uploadFileMultipart({
        file,
        onProgress: (_, loaded: number, total: number) =>
          onProgressUpload(loaded, total),
        onError: () => onErrorUpload(),
      });
    },
    [uploadFileMultipart]
  );

  // Upload quickUploadFile from QuickUploadFile
  // context if present
  useEffect(() => {
    if (quickUploadFile) {
      onUploadFile(quickUploadFile);
    }
  }, [onUploadFile, quickUploadFile]);

  const onCancelUpload = () => {
    // TODO : Will be implemented by WHEEL-789
    // https://anchorfm.atlassian.net/browse/WHEEL-789
    setUploading(false);
    setMedia(null);
  };

  const onDeleteUpload = () => {
    // TODO : Will be implemented by WHEEL-827
    // https://anchorfm.atlassian.net/browse/WHEEL-827
  };

  const renderContent = () => {
    if (isUploading) {
      return (
        <UploadingState
          percentageComplete={uploadPercentage}
          onCancel={onCancelUpload}
        />
      );
    }
    if (isProcessing) {
      return <UploadingState onCancel={onDeleteUpload} isProcessing={true} />;
    }
    if (!media) {
      return <IdleState onUploadFile={onUploadFile} />;
    }
    if (isMultiSegmentFile(media)) {
      // TODO : Will be implemented by WHEEL-783
      // https://anchorfm.atlassian.net/browse/WHEEL-783
      return null;
    }
    return <SingleFileState file={media} />;
  };

  return (
    <div>
      <EpisodeContentLabel>Episode content</EpisodeContentLabel>
      <UploaderStateContainer
        isExpanded={!media || isMultiSegmentFile(media)}
        containsMedia={!!media}
      >
        {renderContent()}
      </UploaderStateContainer>
    </div>
  );
};
